const SESSION_KEY = 'x_iam_superadmin_session';
const REMEMBER_KEY = 'x_iam_superadmin_session_persistent';

export interface SessionPayload {
  signedInAt: string;
}

/**
 * Returns whether a superadmin session exists for this browser (tab or persistent).
 */
export function isAuthenticated(): boolean {
  try {
    return Boolean(sessionStorage.getItem(SESSION_KEY) ?? localStorage.getItem(REMEMBER_KEY));
  } catch {
    return false;
  }
}

/**
 * Persists a signed-in marker. When `remember` is true, survives browser restarts via localStorage.
 */
export function persistSession(options: { remember: boolean }): void {
  const payload: SessionPayload = { signedInAt: new Date().toISOString() };
  const encoded = JSON.stringify(payload);
  sessionStorage.setItem(SESSION_KEY, encoded);
  if (options.remember) {
    localStorage.setItem(REMEMBER_KEY, encoded);
  } else {
    localStorage.removeItem(REMEMBER_KEY);
  }
}

/** Clears all session markers (sign out). */
export function clearSession(): void {
  sessionStorage.removeItem(SESSION_KEY);
  localStorage.removeItem(REMEMBER_KEY);
}
